import './CaixaArredondada.css'
const CaixaArredondada = (props) => {
    var centralizado = ""
    var invertido = ""
    var cor_diferenciada = ""
    var cor_fundo = props.cor_fundo_dark;
    if(props.theme === 'light'){
        cor_fundo = props.cor_fundo_light;
    }
    if(props.centralizado == true)
    {
        centralizado = "center"
    }
    if(props.invertido == true)
    {
        invertido = " "
        cor_diferenciada = "branco"
    }
    else{
        invertido = " cor_cinza"
    }
    return(
        <div style={{backgroundColor:cor_fundo}} className={"just-padding " + centralizado}>
            <div className="txt_title_partners lang-en">{props.titulo}</div>
            {props.children}
            <br></br>
        </div>
    )
}

export default CaixaArredondada